// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1azh4","row":"ProcedureTreatmentSummary_row__RYSnb"};